import React, { useState } from "react";
import "../CSS/RegesterStudentModal.css";
import Cookies from "js-cookie";

const RegisterStudentModal = ({ onClose, onStudentRegistered, refrsh }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    idNumber: "",
    phone: "",
    county: "",
    institute: "",
    course: "",
    agent_ID: Cookies.get("agent_name")
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  //const agent_ID = 20;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    // Basic validation
    if (
      !formData.fullName ||
      !formData.idNumber ||
      !formData.phone ||
      !formData.county ||
      !formData.institute ||
      !formData.course
    ) {
      setError("Please fill in all student details.");
      return;
    }

    try {
      setSubmitting(true);

      /*
       * Replace this URL with your actual PHP endpoint.
       */

      const response = await fetch(
        "https://advenwarecareerlink.com/acl/Agent/Regester_student.php",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

     
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to register student.");
      }

      const data = await response.json();
   
      if(data.message == 'ok')
      {
        alert('regestration was a success')
        refrsh()
      }

      else{
         setError(
        "Unable to register student. Please try again."
      );
      }
      

      if (onStudentRegistered) {
        onStudentRegistered(data.student);
      }

      // Close popup
      onClose();

    } catch (err) {
      console.error(err);

      setError(
        "Unable to register student. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="register-modal-overlay">

      <div className="register-modal">

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="register-modal-header">

          <div>
            <div className="register-modal-label">
              FIELD AGENT
            </div>

            <h2>
              Register student
            </h2>

            <p>
              Enter the student's details below.
            </p>
          </div>

          <button
            className="register-modal-close"
            onClick={onClose}
            type="button"
            aria-label="Close"
          >
            ×
          </button>

        </div>

        {/* =================================================
            ERROR
        ================================================= */}

        {error && (
          <div className="register-modal-error">
            <span>!</span>
            {error}
          </div>
        )}

        {/* =================================================
            FORM
        ================================================= */}

        <form
          className="register-student-form"
          onSubmit={handleSubmit}
        >

          {/* FULL NAME */}

          <div className="form-group full-width">

            <label>
              Full name
            </label>

            <input
              type="text"
              name="fullName"
              placeholder="Enter student's full name"
              value={formData.fullName}
              onChange={handleChange}
            />

          </div>

          {/* ID NUMBER */}

          <div className="form-group">

            <label>
              ID number
            </label>

            <input
              type="text"
              name="idNumber"
              placeholder="Enter ID number"
              value={formData.idNumber}
              onChange={handleChange}
            />

          </div>

          {/* PHONE */}

          <div className="form-group">

            <label>
              Phone number
            </label>

            <input
              type="tel"
              name="phone"
              placeholder="07XXXXXXXX"
              value={formData.phone}
              onChange={handleChange}
            />

          </div>

          {/* COUNTY */}

          <div className="form-group">

            <label>
              County
            </label>

            <select
              name="county"
              value={formData.county}
              onChange={handleChange}
            >

              <option value="">
                Select county
              </option>

              <option value="Baringo">
                Baringo
              </option>

              <option value="Bomet">
                Bomet
              </option>

              <option value="Bungoma">
                Bungoma
              </option>

              <option value="Busia">
                Busia
              </option>

              <option value="Elgeyo-Marakwet">
                Elgeyo-Marakwet
              </option>

              <option value="Embu">
                Embu
              </option>

              <option value="Garissa">
                Garissa
              </option>

              <option value="Homa Bay">
                Homa Bay
              </option>

              <option value="Isiolo">
                Isiolo
              </option>

              <option value="Kajiado">
                Kajiado
              </option>

              <option value="Kakamega">
                Kakamega
              </option>

              <option value="Kericho">
                Kericho
              </option>

              <option value="Kiambu">
                Kiambu
              </option>

              <option value="Kilifi">
                Kilifi
              </option>

              <option value="Kirinyaga">
                Kirinyaga
              </option>

              <option value="Kisii">
                Kisii
              </option>

              <option value="Kisumu">
                Kisumu
              </option>

              <option value="Kitui">
                Kitui
              </option>

              <option value="Kwale">
                Kwale
              </option>

              <option value="Laikipia">
                Laikipia
              </option>

              <option value="Lamu">
                Lamu
              </option>

              <option value="Machakos">
                Machakos
              </option>

              <option value="Makueni">
                Makueni
              </option>

              <option value="Mandera">
                Mandera
              </option>

              <option value="Marsabit">
                Marsabit
              </option>

              <option value="Meru">
                Meru
              </option>

              <option value="Migori">
                Migori
              </option>

              <option value="Mombasa">
                Mombasa
              </option>

              <option value="Murang'a">
                Murang'a
              </option>

              <option value="Nairobi">
                Nairobi
              </option>

              <option value="Nakuru">
                Nakuru
              </option>

              <option value="Nandi">
                Nandi
              </option>

              <option value="Narok">
                Narok
              </option>

              <option value="Nyamira">
                Nyamira
              </option>

              <option value="Nyandarua">
                Nyandarua
              </option>

              <option value="Nyeri">
                Nyeri
              </option>

              <option value="Samburu">
                Samburu
              </option>

              <option value="Siaya">
                Siaya
              </option>

              <option value="Taita-Taveta">
                Taita-Taveta
              </option>

              <option value="Tana River">
                Tana River
              </option>

              <option value="Tharaka-Nithi">
                Tharaka-Nithi
              </option>

              <option value="Trans Nzoia">
                Trans Nzoia
              </option>

              <option value="Turkana">
                Turkana
              </option>

              <option value="Uasin Gishu">
                Uasin Gishu
              </option>

              <option value="Vihiga">
                Vihiga
              </option>

              <option value="Wajir">
                Wajir
              </option>

              <option value="West Pokot">
                West Pokot
              </option>

            </select>

          </div>

          {/* INSTITUTE */}

          <div className="form-group">

            <label>
              Institute
            </label>

            <input
              type="text"
              name="institute"
              placeholder="University / college"
              value={formData.institute}
              onChange={handleChange}
            />

          </div>

          {/* COURSE */}

          <div className="form-group">

            <label>
              Current course
            </label>

            <input
              type="text"
              name="course"
              placeholder="e.g. Computer Science"
              value={formData.course}
              onChange={handleChange}
            />

          </div>

          {/* BUTTONS */}

          <div className="register-form-actions">

            <button
              type="button"
              className="cancel-register-button"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="submit-register-button"
              disabled={submitting}
            >
              {submitting
                ? "Registering..."
                : "Register student"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
};

export default RegisterStudentModal;